import * as React from "react"
import { Link } from "gatsby"
import { AnimatePresence, motion } from "framer-motion"
import Logo from "./Logo"

const LoveRain = () => {
  const containerAni = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.35,
        ease: "easeIn",
        duration: 12,
        when: "afterChildren",
      },
      transitionEnd: {
        display: "none",
      },
    },
    exit: {},
  }

  const rainAni = {
    hidden: {
      opacity: 0,
    },
    show: {
      opacity: [0, 1, 1, 1, 0],
      y: ["0%", "100%"],
      transition: {
        ease: "easeIn",
        duration: 6,
      },
    },
  }

  return (
    <motion.div
      className="fixed inset-0 z-50 flex justify-between px-10"
      initial="hidden"
      animate="show"
      variants={containerAni}
    >
      {Array.apply(null, { length: 20 }).map((x, i) => (
        <motion.div key={i} variants={rainAni}>
          ❤️
        </motion.div>
      ))}
    </motion.div>
  )
}

const DarkToggle = ({ dark, setDark }) => {
  const toggle = () => {
    const next = !dark
    setDark(next)
    document.getElementsByTagName("html")[0].classList.toggle("dark", next)
  }

  return (
    <button
      onClick={toggle}
      aria-label={dark ? "Passer en mode clair" : "Passer en mode sombre"}
      className="flex h-8 w-8 items-center justify-center rounded text-eido-grey-500 transition-colors hover:text-eido-grey-900 dark:text-eido-grey-500 dark:hover:text-eido-grey-200"
    >
      {dark ? (
        /* Soleil */
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-5 w-5">
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z" />
        </svg>
      ) : (
        /* Lune */
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-5 w-5">
          <path strokeLinecap="round" strokeLinejoin="round" d="M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998Z" />
        </svg>
      )}
    </button>
  )
}

const Header = ({ isLove, word, setIsOpen, dark, setDark }) => {
  return (
    <header className="container mx-auto flex items-start justify-between py-6 px-2">
      <Link to={"/"} className="w-1/2 md:w-full md:max-w-xl">
        <motion.div className="fill-eido-grey-500 transition-all dark:fill-eido-grey-200">
          <Logo />
        </motion.div>
        {isLove ? <LoveRain /> : null}
        {word && <span>{word}</span>}
      </Link>
      <div className="flex items-center space-x-3">
        <DarkToggle dark={dark} setDark={setDark} />
        <button
          className="flex items-center space-x-2 rounded bg-gradient-to-t from-[rgba(255,106,0,1)] to-[rgba(255,157,0,1)] px-1 py-0.5 text-white md:px-4 md:py-1"
          onClick={() => setIsOpen(true)}
        >
          <span className="hidden text-xs md:inline-block md:text-lg">
            Démarrez votre projet
          </span>
          <span className="inline-block text-xs md:hidden md:text-lg">
            Start projet
          </span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="h-6 w-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15.59 14.37a6 6 0 01-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 006.16-12.12A14.98 14.98 0 009.631 8.41m5.96 5.96a14.926 14.926 0 01-5.841 2.58m-.119-8.54a6 6 0 00-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 00-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 01-2.448-2.448 14.9 14.9 0 01.06-.312m-2.24 2.39a4.493 4.493 0 00-1.757 4.306 4.493 4.493 0 004.306-1.758M16.5 9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
            />
          </svg>
        </button>
      </div>
    </header>
  )
}

export default Header
